import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Icon } from '@iconify/react/dist/iconify.js';
import { getstock , removeStock, addStock } from "../Api"; // Assuming getstock is a function that fetches stock data
const MyStocks = () => {

  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [SelectedStock, SetSelectedStock] = useState([]);
  

  const handleRemoveStock = async (stock) => {
  try {
    await removeStock(stock);
    SetSelectedStock(prev => prev.filter(s => s.stock !== stock.stock));
  } catch (error) {
    console.error("Failed to remove stock:", error);
  }
};

const handleAddStock = (stock) => {
    try {
    addStock(stock); 
    SetSelectedStock(prev => [...prev, { stock: stock.stock }]);
  } catch (error) {
    console.error("Failed to add stock:", error);
  }  
};

  useEffect(() => {
  if (query.trim().length < 3) {
    setResults([]);
    return;
  }

  const timeoutId = setTimeout(() => {

    console.log(query);

    getstock(query)
      .then(data => {
        setResults(data['userstocks'])
        SetSelectedStock(data['selectedstocks']);
      })
      .catch(() => setResults([]));
  }, 500); // debounce for 500ms

  return () => clearTimeout(timeoutId);
}, [query]);



  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="My Stocks" />

            <div className="col-md-12 mb-3">
            <div className="card">
                <div className="card-body">
                    <div className="row gy-3">
                        <div className="col-12">
                            <label className="form-label" style={{fontSize:'18px',fontWeight:"normal",marginBottom:"0px"}}>Stock usage</label>
                            <p className="text-muted mb-3" style={{fontSize:'14px'}}>You're tracking 3 out of 3 available stocks.</p>
                            <p className="text-muted mb-3" style={{fontSize:'14px'}}>You've reached the maximum number of stocks for your Basic Plan. Upgrade to add more.</p>
                        </div>
                    
                    </div>
                </div>
            </div>
            </div>

            <div className="col-md-12">
            <div className="card">
                <div className="card-body">
                    <div className="row gy-3">
                        <div className="col-12">
                            <label className="form-label" style={{fontSize:'18px',fontWeight:"normal",marginBottom:"0px"}}>Add stocks</label>
                            <p className="text-muted mb-3" style={{fontSize:'14px'}}>Search and add stocks to your watchlist.</p>
                            <input
                                type="text"
                                className="form-control"
                                value={query}
                                onChange={e => setQuery(e.target.value)}
                                placeholder="Search stocks..."
                            />
                        </div>
                    
                    </div>
                </div>
            </div>
            </div>

            <div className="col-md-12 mt-3">
            <div className="card">
                <div className="card-body">
                    <div className="row gy-3">
                        <div className="col-12">
                            <label className="form-label" style={{fontSize:'18px',fontWeight:"normal",marginBottom:"0px"}}>Current watchlist</label>
                            <p className="text-muted mb-3" style={{fontSize:'14px'}}>Manage the stocks you're tracking</p>
                        </div>                    
                    </div>
                    {results.length > 0 && results.map((stock, index) => (
                    <div key={index} className="row gy-3 each_row_css">
                        <div className="col-8">
                            <p className="mb-0">{stock.date}</p>
                            <p className="text-muted mb-0">{stock.description}</p>
                        </div>
                        <div className="col-2">
                            <p className="text-muted mb-0">{stock.price}</p>
                            <p className={stock['price_movement']['movement'] == 'Up' ? "text-success stock_momnet" : "text-danger stock_momnet"}>
                                {stock['price_movement']['percentage']}% {stock['price_movement']['movement'] == 'Up' ? '↑' : '↓'}
                            </p>
                        </div>
                        {
                            SelectedStock.some(s => s.stock === stock.stock) ? (
                                <div className="col-2">
                                    <button className="btn btn-danger btn-sm" style={{width:'100%'}} onClick={() => handleRemoveStock(stock)} >
                                        <Icon icon="mdi:close" style={{fontSize:'16px'}} /> Remove
                                    </button>
                                </div>
                            ) : (
                                <div className="col-2">
                                    <button className="btn btn-primary btn-sm" style={{width:'100%'}} onClick={() => handleAddStock(stock)}>
                                        <Icon icon="mdi:plus" style={{fontSize:'16px'}} /> Add
                                    </button>
                                </div>
                            )
                        }

                    </div>
                    ))}

                    {results.length === 0 && (
                        <div className="text-center mt-4">
                            <p className="text-muted">No stocks found. Please search for stocks to add to your watchlist.</p>
                        </div>
                    )}

                </div>
            </div>
            </div>


      </MasterLayout>

    </>
  );
};

export default MyStocks;
